import Vue from 'vue'

// filters
import filters from '@/filters'

import unload from '@/plugins/unload'
import svgIcons from './svgIcons'
import registerGlobalComponents from './registerGlobalComponents'
import vant from './vant'
import clipboard from './clipboard'
import activeElementScrollIntoView from './activeElementScrollIntoView'

export default {
  install: () => {
    Vue.use(svgIcons)
    Vue.use(registerGlobalComponents)
    Vue.use(unload)
    // Vue.use(activeElementScrollIntoView);
    Vue.use(vant)
    Vue.use(clipboard)

    Vue.use(filters)
  },
}
